export default __webpack_public_path__ + "static/media/hdpe-pipes.edeefd66.jpg";